  
  


  
  <!-- 彈窗 選擇附加品項-->
<ng-template #Modal let-data let-ref="dialogRef">
  <nb-card class="staffInfoTemplate" [nbSpinner]="info.IsLoding">
    <nb-card-header>
      {{ title }}
      <div class="row mx-0 mt-3">
        <input
          class="col"
          [(ngModel)]="query.searchKey"
          name="searchKey"
          type="text"
          nbInput
          fullWidth
          shape="rectangle"
          [placeholder]="t('common_search_option_name', '查詢選項名稱')">
        <button class="col-auto ml-2 btn" nbButton (click)="onQuery()">
          <i class="fas fa-search"></i>
        </button>
      </div>
      <div class="d-flex mx-0 mt-2 justify-content-between">
        <button class="col-auto mr-auto btn" nbButton (click)="onSelectAll()">
          {{ status.isSelectAll ? t('common_cancel_all', '取消全選') : t('common_select_all', '全選') }}
        </button>
        <nb-select class="col-auto pr-0" style="width:180px" [(ngModel)]="selectORG_Store_ID" (selectedChange)="onQuery()">
          <nb-option *ngFor="let e of storeSelectList" [value]="e.value">{{ e.content }}</nb-option>
        </nb-select>
        <nb-select class="col-auto pr-0" style="width:100px" [(ngModel)]="status.showType" (selectedChange)="onShowType()">
          <nb-option *ngFor="let e of list.showType" [value]="e.value">{{ e.name }}</nb-option>
        </nb-select>
      </div>
    </nb-card-header>
    <nb-card-body>
      <div class="">
        <table class="table table-bordered table-striped">
          <thead>
            <tr>
              <th>{{ t('common_select', '選擇') }}</th>
              <th>{{ t('common_option_name', '選項名稱') }}</th>
              <th>{{ t('common_quantity', '數量') }}</th>
              <th>{{ t('common_original_price', '原價') }}</th>
              <th>{{ t('common_create_store', '建立門市') }}</th>
            </tr>
          </thead>
          <tbody *ngIf="showList">
            <tr *ngFor="let item of showList; let j = index">
              <td *ngIf="item.isSelect" (click)="onSelect(false,item)">
                <button class="btn btn-info py-0 px-1 checkbtn"><i class="fa fa-check"></i></button>
              </td>
              <td *ngIf="!item.isSelect" (click)="onSelect(true,item)">
                <button class="btn btn-info py-0 px-1 checkbtn"></button>
              </td>
              <td style="vertical-align: middle;">
                {{item.ItemName}}
                <br/>
              </td>
              <td style="vertical-align: middle;">{{item.Quantity}}</td>
              <td style="vertical-align: middle;">{{item.Cash}}</td>
              <td style="vertical-align: middle;">{{item.CreateStoreName}}</td>
            </tr>
          </tbody>
        </table>
      </div>
    </nb-card-body>
    <nb-card-footer>
      <button nbButton class="btn btn-info" (click)="onSave()">{{ t('common_confirm', '確定') }}</button>
      <button nbButton (click)="ref.close()">{{ t('common_close', '關閉') }}</button>
    </nb-card-footer>
  </nb-card>
</ng-template>
